import { PENDING_QUOTES, REMOVE_PENDING_QUOTE, UNASSIGNED_QUOTES, REMOVE_UNASSIGNED_QUOTES, URGENT_QUOTES, REMOVE_URGENT_QUOTES, ONGOING_QUOTES, INCOMPLETE_QUOTES, REMOVE_INCOMPLETE_QUOTES, UPDATE_INCOMPLETE_QUOTES, NEW_QUOTES, REMOVE_NEW_QUOTE, DECLINED_QUOTES, REMOVE_DECLINED_QUOTES, COMPLETED_QUOTES, REMOVE_COMPLETED_QUOTES, APPROVED_QUOTES, REMOVE_APPROVED_QUOTES, CONCLUDED_QUOTES, UPDATE_CONCLUDED_QUOTES } from '../constants/actionTypes'

const quoteActions = (quotes = { pending: [], unassigned: [], urgent: [], ongoing: [], incomplete: [], new: [], declined: [], completed: [], approved: [], concluded: [] }, action) => {
    switch (action.type) {
        case PENDING_QUOTES:
            return {...quotes, pending:[...quotes.pending, ...action?.payload]}
        case REMOVE_PENDING_QUOTE:
            const pendingIndex = quotes.pending.findIndex((quote) => 
                quote.id === action.id
            )
            let pendingQuotes = [...quotes.pending]

            if(pendingIndex !== -1) {
                pendingQuotes.splice(pendingIndex, 1)
            }
            
            return {...quotes, pending: pendingQuotes}
        case NEW_QUOTES:
            return {...quotes, new:[...quotes.new, ...action?.payload]}
        case REMOVE_NEW_QUOTE:
            const newIndex = quotes.new.findIndex((quote) => 
                quote._id === action.id
            )
            let newQuotes = [...quotes.new]

            if(newIndex !== -1) {
                newQuotes.splice(newIndex, 1)
            }
            
            return {...quotes, new: newQuotes}
        case COMPLETED_QUOTES:
            return {...quotes, completed:[...quotes.completed, ...action?.payload]}
        case REMOVE_COMPLETED_QUOTES:
            const completedIndex = quotes.completed.findIndex((quote) => 
                quote._id === action.id
            )
            let completedQuotes = [...quotes.completed]

            if(completedIndex !== -1) {
                completedQuotes.splice(completedIndex, 1)
            }
            
            return {...quotes, completed: completedQuotes}
        case UNASSIGNED_QUOTES:
            return {...quotes, unassigned:[...quotes.unassigned, ...action?.payload]}
        case REMOVE_UNASSIGNED_QUOTES:
            const unassignedIndex = quotes.unassigned.findIndex((quote) => 
                quote.id === action.id
            )
            let unassignedQuotes = [...quotes.unassigned]

            if(unassignedIndex !== -1) {
                unassignedQuotes.splice(unassignedIndex, 1)
            }
            
            return {...quotes, unassigned: unassignedQuotes}
        case APPROVED_QUOTES:
            return {...quotes, approved:[...quotes.approved, ...action?.payload]}
        case REMOVE_APPROVED_QUOTES:
            const approvedIndex = quotes.approved.findIndex((quote) => 
                quote.id === action.id
            )
            let approvedQuotes = [...quotes.approved]

            if(approvedIndex !== -1) {
                approvedQuotes.splice(approvedIndex, 1)
            }
            
            return {...quotes, approved: approvedQuotes}
        case URGENT_QUOTES:
            return {...quotes, urgent:[...quotes.urgent, ...action?.payload]}
        case REMOVE_URGENT_QUOTES:
            const urgentIndex = quotes.urgent.findIndex((quote) => 
                quote.id === action.id
            )
            let urgentQuotes = [...quotes.urgent]

            if(urgentIndex !== -1) {
                urgentQuotes.splice(urgentIndex, 1)
            }
            
            return {...quotes, urgent: urgentQuotes}
        case ONGOING_QUOTES:
            return {...quotes, ongoing:[...quotes.ongoing, ...action?.payload]}
        case CONCLUDED_QUOTES:
            return {...quotes, concluded:[...quotes.concluded, ...action?.payload]}
        case UPDATE_CONCLUDED_QUOTES:
            const concludedIndex = quotes.concluded.findIndex((quote) => 
                quote.id === action.id
            )
            let concludedQuotes = quotes.concluded
            
            concludedQuotes[concludedIndex] = action.quote
            
            return {...quotes, concluded: concludedQuotes}
        case DECLINED_QUOTES:
            return {...quotes, declined:[...quotes.declined, ...action?.payload]}
        case REMOVE_DECLINED_QUOTES:
            const declinedIndex = quotes.declined.findIndex((quote) => 
                quote.id === action.id
            )
            let declinedQuotes = [...quotes.declined]

            if(declinedIndex !== -1) {
                declinedQuotes.splice(declinedIndex, 1)
            }
            
            return {...quotes, declined: declinedQuotes}
        case INCOMPLETE_QUOTES:
            return {...quotes, incomplete:[...quotes.incomplete, ...action?.payload]}
        case REMOVE_INCOMPLETE_QUOTES:
            const incompleteIndex = quotes.incomplete.findIndex((quote) => 
                quote.id === action.id
            )
            let incompleteQuotes = [...quotes.incomplete]

            if(incompleteIndex !== -1) {
                incompleteQuotes.splice(incompleteIndex, 1)
            }
            
            return {...quotes, incomplete: incompleteQuotes}
        case UPDATE_INCOMPLETE_QUOTES:
                const updatedIncompleteQuote = quotes.incomplete.map((quote) => {
                    if(quote.id === action.id) quote.allocation = action.payload
                    
                    return quote
                })

            return {...quotes, incomplete: updatedIncompleteQuote}
        default:
            return quotes;
    }
}

export default quoteActions